import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { MergeStep } from '@core/merging-types';

export enum MergeMethod {
  Bulk = 'bulk',
  MergeWith = 'mergeWith',
  CandidateProfileTopBar = 'candidateProfileTopBar',
}

export type MergeCandidatesPayload = {
  candidatesMerged: number;
  candidatesSimilar: number;
  candidatesSeparated: number;
  method: MergeMethod;
};

@Injectable()
export class CandidateMergeAnalytics extends AnalyticsBase {
  public readonly namespace = 'CandidatesMerge';
  public readonly requireViewContext = true;

  public trackMergeCandidates(mergeCandidatesPayload: MergeCandidatesPayload): void {
    this.track('MergeProfiles', mergeCandidatesPayload);
  }

  public trackOpenMergingDialog(payload: { method: MergeMethod; candidatesSimilar: number }): void {
    this.track('OpenMergingDialog', payload);
  }

  public trackCancelMerging(step: MergeStep): void {
    this.track('CancelMerging', { step });
  }

  public trackBackToCompare(): void {
    this.track('BackToCompare');
  }

  public trackHowItWorks(action: 'expand' | 'collapse'): void {
    this.track('HowItWorks', { action });
  }
}
